"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalDialog = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _getSize = require("./getSize");
var _ModalDialog = require("./ModalDialog.styles");
/**
 * A modal dialog component, also commonly know simply as a "modal" or a "lightbox".
 *
 * All props are passed to the underlying `Dialog` component.
 *
 * ##### Known Limitations
 * * In IE11, dialogs always take up the full height of the screen.
 *
 * @extends Modal
 * @related ['Dialog']
 * @since 5.0.0
 */
var ModalDialog = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_ModalDialog.StyledModalDialog, (0, _extends2.default)({
    "aria-modal": "true",
    ref: forwardedRef
  }, props, {
    size: (0, _getSize.getSize)(props)
  }));
});
exports.ModalDialog = ModalDialog;
ModalDialog.displayName = 'ModalDialog';
ModalDialog.propTypes = {
  /**
   * Display divider lines between header, body, and footer sections.
   *
   * @since 8.54.0
   */
  dividers: _propTypes.default.bool,
  /**
   * By default, when there is overflow content in the dialog body, the body will scroll within
   * the dialog bounds. Optionally, you can disable scrolling on the dialog body and instead
   * have the entire dialog scroll within the document bounds.
   */
  scrollDocument: _propTypes.default.bool,
  /**
   * The size of a modal dialog.
   *
   * Supports inline media query objects
   *
   * @since 8.54.0
   */
  size: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(Object.values(_constants.MODAL_SIZES))),
  /**
   * @deprecated Use the `size="fullScreen"` prop.
   */
  fullScreen: _customPropTypes.default.inlineMediaQuery(_propTypes.default.bool),
  /**
   * @deprecated Use the `size="md"` prop.
   */
  wide: _propTypes.default.bool,
  /**
   * @deprecated Use inline media query objects
   */
  mediaQuery: _customPropTypes.default.mediaQuery
};
ModalDialog.defaultProps = {
  dividers: true,
  fullScreen: false,
  size: _constants.MODAL_SIZES.XS,
  wide: false,
  scrollDocument: false
};
ModalDialog.SIZES = _constants.MODAL_SIZES;